// eslint-disable-next-line import/no-extraneous-dependencies
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import Big from 'big.js';
import _ from 'lodash';
import computeWithPriceCartV2 from '../graphql/calculations/mutations/compute-with-price-cart.gql';
import { CALCULATION_PRICE_SERVICE } from '../constants';
import { Receipt } from './receipt';
import { mapInputsForPriceCartAPI, updateReceiptFromPriceCartAPI } from './utilities';
import { taxes } from './taxes';
var handlePriceCartRequest = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(param) {
        var apolloClient, restApi, priceCartInput, priceService, input, body, url;
        return _ts_generator(this, function(_state) {
            apolloClient = param.apolloClient, restApi = param.restApi, priceCartInput = param.priceCartInput, priceService = param.priceService;
            if (apolloClient) {
                // we only want to add this on cart requests, not server-orders or D+
                input = Object.assign(priceCartInput, {
                    includeGamification: true
                });
                return [
                    2,
                    apolloClient.mutate({
                        mutation: computeWithPriceCartV2,
                        variables: {
                            priceCartInput: input
                        }
                    })
                ];
            }
            body = {
                input: priceCartInput
            };
            url = priceService === CALCULATION_PRICE_SERVICE.plus ? "/plus_enterprise/checkouts/price_cart_v2" : "/rest/carts/price_cart_v2";
            return [
                2,
                restApi.post(url, body)
            ];
        });
    });
    return function handlePriceCartRequest(_) {
        return _ref.apply(this, arguments);
    };
}();
export function priceCartComputer(_, logger, apolloClient, restApi, priceService) {
    return _priceCartComputer.apply(this, arguments);
}
function _priceCartComputer() {
    _priceCartComputer = _async_to_generator(function(param, logger, apolloClient, restApi, priceService) {
        var appliedRewards, cart, cartAddress, couponObject, couponActions, deliveryOption, deliveryScheduleType, dispensary, loyaltyPointsApplied, medicalOrder, paymentMethod, payerId, posCustomerId, rewardActions, tipValue, toMenu, userId, preOrderType, platformType, _param_roundupForCharityEnabled, roundupForCharityEnabled, _response_data, _response_data1, _receipt_summary, _appliedRewards_, _priceCartOutput_discountGamification, _taxes, details, salesTaxExistence, cannabisTaxExistence, bottleDepositTaxExistence, receipt, priceCartInput, response, error, hasTimeoutError, logMessage, _response_data_computeWithPriceCartV2, priceCartOutput, mixAndMatchEnabled, pricingTierTotalPerOrder, feeTotals, discountIncentives, rewardDiscount, couponOutput, credit, roundupForCharityAmount, transactionRounding, ref, cartProductKeys, coupon, tip, _tipValue_, _tipValue__dollar, _tipValue_dollar, roundupForCharityAmountInDollars, _priceCartOutput_grandTotal, baseTotal, total, _priceCartOutput_discountGamification_gamificationDetails, _priceCartOutput_resolvedZoneIds;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    appliedRewards = param.appliedRewards, cart = param.cart, cartAddress = param.cartAddress, couponObject = param.coupon, couponActions = param.couponActions, deliveryOption = param.deliveryOption, deliveryScheduleType = param.deliveryScheduleType, dispensary = param.dispensary, loyaltyPointsApplied = param.loyaltyPointsApplied, medicalOrder = param.medicalOrder, paymentMethod = param.paymentMethod, payerId = param.payerId, posCustomerId = param.posCustomerId, rewardActions = param.rewardActions, tipValue = param.tipValue, toMenu = param.toMenu, userId = param.userId, preOrderType = param.preOrderType, platformType = param.platformType, _param_roundupForCharityEnabled = param.roundupForCharityEnabled, roundupForCharityEnabled = _param_roundupForCharityEnabled === void 0 ? false : _param_roundupForCharityEnabled;
                    if (!dispensary || !cart) {
                        return [
                            2,
                            {}
                        ];
                    }
                    _taxes = taxes(cart, dispensary, medicalOrder, deliveryOption === 'delivery', toMenu), details = _taxes.details, salesTaxExistence = _taxes.salesTaxExistence, cannabisTaxExistence = _taxes.cannabisTaxExistence, bottleDepositTaxExistence = _taxes.bottleDepositTaxExistence;
                    receipt = new Receipt(dispensary);
                    priceCartInput = {};
                    try {
                        priceCartInput = mapInputsForPriceCartAPI({
                            cart: cart,
                            address: cartAddress,
                            deliveryOption: deliveryOption,
                            medicalOrder: medicalOrder,
                            userId: userId,
                            dispensaryId: dispensary.id,
                            paymentMethod: paymentMethod,
                            couponCode: couponObject === null || couponObject === void 0 ? void 0 : couponObject.code,
                            appliedRewards: appliedRewards,
                            loyaltyPointsApplied: loyaltyPointsApplied,
                            deliveryScheduleType: deliveryScheduleType,
                            payerId: payerId,
                            posCustomerId: posCustomerId,
                            preOrderType: preOrderType,
                            platformType: platformType
                        });
                    } catch (error) {
                        logger.error('Invalid product data in cart', {
                            priceService: priceService,
                            dispensaryId: dispensary.id,
                            cart: cart
                        });
                        throw error;
                    }
                    if (_.isEmpty(priceCartInput.cart)) {
                        receipt.finalize();
                        return [
                            2,
                            emptyCartResponse(receipt)
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        handlePriceCartRequest({
                            apolloClient: apolloClient,
                            restApi: restApi,
                            priceCartInput: priceCartInput,
                            priceService: priceService
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    hasTimeoutError = extractTimeoutError(error);
                    logMessage = hasTimeoutError ? 'Price cart calculation timed out' : 'Price cart calculation failed - will fallback to legacy';
                    logger.error(logMessage, {
                        dispensaryId: dispensary.id,
                        priceService: priceService,
                        error: error.message
                    });
                    return [
                        2,
                        {
                            shouldFallback: true,
                            timedOut: hasTimeoutError,
                            priceCartError: error.message
                        }
                    ];
                case 4:
                    priceCartOutput = (_response_data_computeWithPriceCartV2 = (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.computeWithPriceCartV2) !== null && _response_data_computeWithPriceCartV2 !== void 0 ? _response_data_computeWithPriceCartV2 : (_response_data1 = response.data) === null || _response_data1 === void 0 ? void 0 : _response_data1.attributes;
                    mixAndMatchEnabled = getMixAndMatchValue(dispensary.storeSettings, deliveryOption === 'delivery');
                    try {
                        ;
                        ref = updateReceiptFromPriceCartAPI({
                            priceCartOutput: priceCartOutput,
                            receipt: receipt,
                            cartItems: cart,
                            tipValue: tipValue,
                            logger: logger,
                            mixAndMatchEnabled: mixAndMatchEnabled,
                            roundupForCharityEnabled: roundupForCharityEnabled
                        }), pricingTierTotalPerOrder = ref.pricingTierTotalPerOrder, feeTotals = ref.feeTotals, discountIncentives = ref.discountIncentives, rewardDiscount = ref.rewardDiscount, couponOutput = ref.couponOutput, credit = ref.credit, roundupForCharityAmount = ref.roundupForCharityAmount, transactionRounding = ref.transactionRounding, ref;
                    } catch (error) {
                        cartProductKeys = cart ? Object.values(cart).map(function(item) {
                            return item.key ? "".concat(item.key, "_").concat(item.quantity || 0) : null;
                        }).filter(Boolean) : [];
                        logger.error('Failed to update receipt from price cart API', {
                            dispensaryId: dispensary.id,
                            priceService: priceService,
                            error: error.message,
                            cartItemPricesExists: !!(priceCartOutput === null || priceCartOutput === void 0 ? void 0 : priceCartOutput.cartItemPrices),
                            cartProductKeys: cartProductKeys,
                            priceCartOutput: priceCartOutput || {}
                        });
                        throw error;
                    }
                    coupon = handleDiscountByCode({
                        couponOutput: couponOutput,
                        couponActions: couponActions,
                        dispensaryId: dispensary.id,
                        priceService: priceService,
                        couponObject: couponObject
                    });
                    handleRewardValidation({
                        rewardErrors: priceCartOutput === null || priceCartOutput === void 0 ? void 0 : priceCartOutput.rewardValidationErrors,
                        rewardActions: rewardActions
                    });
                    receipt.finalize();
                    if (_.isArray(tipValue) && tipValue.length > 0) {
                        ;
                        ;
                        tip = (_tipValue__dollar = (_tipValue_ = tipValue[0]) === null || _tipValue_ === void 0 ? void 0 : _tipValue_.dollar) !== null && _tipValue__dollar !== void 0 ? _tipValue__dollar : 0;
                    } else {
                        ;
                        tip = (_tipValue_dollar = tipValue === null || tipValue === void 0 ? void 0 : tipValue.dollar) !== null && _tipValue_dollar !== void 0 ? _tipValue_dollar : 0;
                    }
                    roundupForCharityAmountInDollars = centsToDollars(roundupForCharityAmount);
                    // Use originalTotal when roundup active, else grandTotal (fallback to originalTotal)
                    baseTotal = roundupForCharityAmountInDollars > 0 ? priceCartOutput.originalTotal : (_priceCartOutput_grandTotal = priceCartOutput.grandTotal) !== null && _priceCartOutput_grandTotal !== void 0 ? _priceCartOutput_grandTotal : priceCartOutput.originalTotal;
                    total = tip + centsToDollars(baseTotal) + roundupForCharityAmountInDollars;
                    return [
                        2,
                        _object_spread_props(_object_spread({
                            menuTotal: calculateMenuTotal(receipt.details.products, (_receipt_summary = receipt.summary) === null || _receipt_summary === void 0 ? void 0 : _receipt_summary.discounts),
                            cartSubtotal: centsToDollars(priceCartOutput.subTotal),
                            subtotal: centsToDollars(priceCartOutput.subTotal),
                            bottleDepositTaxCents: Number(priceCartOutput.totalBottleDepositTax),
                            cannabisTax: centsToDollars(priceCartOutput.totalCannabisTax),
                            tax: centsToDollars(priceCartOutput.totalSalesTax),
                            deliveryFee: centsToDollars(feeTotals.delivery),
                            credit: centsToDollars(credit),
                            mixAndMatch: centsToDollars(pricingTierTotalPerOrder),
                            reward: centsToDollars(rewardDiscount),
                            tip: tip,
                            otherFees: centsToDollars(feeTotals.other),
                            paymentFee: Number(feeTotals.payment),
                            paymentIncentives: discountIncentives,
                            roundupForCharityAmount: roundupForCharityAmountInDollars,
                            rounding: centsToDollars(transactionRounding),
                            total: total,
                            details: details,
                            lineitems: [
                                {
                                    type: "productSubtotal",
                                    value: centsToDollars(priceCartOutput.subTotal)
                                },
                                {
                                    type: "mixAndMatch",
                                    value: centsToDollars(pricingTierTotalPerOrder)
                                },
                                {
                                    type: "discount",
                                    value: centsToDollars(credit)
                                },
                                {
                                    type: "reward",
                                    value: centsToDollars(rewardDiscount),
                                    brand: !_.isEmpty(appliedRewards) ? (_appliedRewards_ = appliedRewards[0]) === null || _appliedRewards_ === void 0 ? void 0 : _appliedRewards_.brand : "Reward"
                                },
                                {
                                    type: 'paymentFee',
                                    value: centsToDollars(feeTotals.payment)
                                },
                                {
                                    type: 'deliveryFee',
                                    value: centsToDollars(feeTotals.delivery)
                                },
                                {
                                    type: 'otherFees',
                                    value: centsToDollars(feeTotals.other)
                                },
                                {
                                    type: 'tip',
                                    value: tip
                                },
                                {
                                    type: 'bottleDepositTaxCents',
                                    value: Number(priceCartOutput.totalBottleDepositTax)
                                },
                                {
                                    type: 'cannabisTax',
                                    value: centsToDollars(priceCartOutput.totalCannabisTax)
                                },
                                {
                                    type: 'salesTax',
                                    value: centsToDollars(priceCartOutput.totalSalesTax)
                                },
                                {
                                    type: 'rounding',
                                    value: centsToDollars(transactionRounding)
                                },
                                {
                                    type: 'roundupForCharity',
                                    value: roundupForCharityAmountInDollars
                                },
                                {
                                    type: 'total',
                                    value: total
                                }
                            ],
                            salesTaxExistence: salesTaxExistence,
                            cannabisTaxExistence: cannabisTaxExistence,
                            bottleDepositTaxExistence: bottleDepositTaxExistence,
                            receipt: receipt.toJSON()
                        }, priceService === CALCULATION_PRICE_SERVICE.checkout && coupon ? {
                            coupon: coupon
                        } : {}), {
                            timedOut: false,
                            loyaltyAppliedAsDiscount: priceCartOutput.loyaltyAppliedAsDiscount / 100,
                            calculationErrors: getCalculationErrors(priceCartOutput.rewardValidationErrors),
                            gamificationDetails: serializeGamificationDetails((_priceCartOutput_discountGamification_gamificationDetails = (_priceCartOutput_discountGamification = priceCartOutput.discountGamification) === null || _priceCartOutput_discountGamification === void 0 ? void 0 : _priceCartOutput_discountGamification.gamificationDetails) !== null && _priceCartOutput_discountGamification_gamificationDetails !== void 0 ? _priceCartOutput_discountGamification_gamificationDetails : [], cart, extractSpecialsFromCart(cart)),
                            // POS-13717: Include applied discounts with restriction metadata for online membership discounts
                            appliedDiscountsWithMetadata: extractAppliedDiscounts(priceCartOutput.cartItemPrices),
                            // Delivery zones the POS pricing engine resolved for this address; used to narrow the
                            // displayed POS fee config to the fees that actually apply to the delivery location.
                            resolvedZoneIds: (_priceCartOutput_resolvedZoneIds = priceCartOutput.resolvedZoneIds) !== null && _priceCartOutput_resolvedZoneIds !== void 0 ? _priceCartOutput_resolvedZoneIds : []
                        })
                    ];
            }
        });
    });
    return _priceCartComputer.apply(this, arguments);
}
// POS-13717: Extract unique applied discounts with their restriction metadata
var extractAppliedDiscounts = function() {
    var cartItemPrices = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var allDiscounts = _.flatMap(cartItemPrices, function(item) {
        return (item === null || item === void 0 ? void 0 : item.discounts) || [];
    });
    // Deduplicate by discountId, keeping the full metadata
    var uniqueDiscounts = _.uniqBy(allDiscounts, 'discountId');
    return _.map(uniqueDiscounts, function(discount) {
        var _discount_isRestricted, _discount_menuDisplayName, _discount_menuDisplayDescription, _discount_menuDisplayImage;
        return {
            _id: String(discount.discountId),
            discountId: discount.discountId,
            name: discount.name,
            amount: discount.amount,
            applicationMethod: discount.applicationMethod,
            isLoyaltyReward: discount.isLoyaltyReward,
            isPaymentIncentive: discount.isPaymentIncentive,
            // Restriction metadata for online membership discounts
            isRestricted: (_discount_isRestricted = discount.isRestricted) !== null && _discount_isRestricted !== void 0 ? _discount_isRestricted : false,
            menuDisplayName: (_discount_menuDisplayName = discount.menuDisplayName) !== null && _discount_menuDisplayName !== void 0 ? _discount_menuDisplayName : null,
            menuDisplayDescription: (_discount_menuDisplayDescription = discount.menuDisplayDescription) !== null && _discount_menuDisplayDescription !== void 0 ? _discount_menuDisplayDescription : null,
            menuDisplayImage: (_discount_menuDisplayImage = discount.menuDisplayImage) !== null && _discount_menuDisplayImage !== void 0 ? _discount_menuDisplayImage : null
        };
    });
};
function centsToDollars(value) {
    return Number(Big(value).div(100));
}
function getCalculationErrors() {
    var rewardValidationErrors = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return _.map(rewardValidationErrors, function(error) {
        var message = errorMapper[error === null || error === void 0 ? void 0 : error.message];
        return message !== null && message !== void 0 ? message : error === null || error === void 0 ? void 0 : error.message;
    });
}
var errorMapper = {
    'Discount does not apply to any items in cart.': 'Cart is not eligible for this discount'
};
function handleDiscountByCode(param) {
    var couponOutput = param.couponOutput, couponActions = param.couponActions, dispensaryId = param.dispensaryId, priceService = param.priceService, couponObject = param.couponObject;
    if (couponOutput) {
        var couponReturnValue = _object_spread_props(_object_spread({}, couponOutput), {
            dollar: Number(couponOutput.amount),
            code: couponObject.code,
            dispensaryId: dispensaryId,
            active: true,
            oneUsePerCustomer: false,
            addedDate: new Date(),
            _id: String(couponOutput.discountId)
        });
        if (priceService === CALCULATION_PRICE_SERVICE.cart) {
            couponActions.applyCouponCode(couponReturnValue);
            return null;
        }
        return couponReturnValue;
    }
    if (priceService === CALCULATION_PRICE_SERVICE.cart && couponObject) {
        couponActions.removeCoupon();
    }
    return null;
}
function handleRewardValidation(param) {
    var rewardErrors = param.rewardErrors, rewardActions = param.rewardActions;
    if (rewardErrors && rewardErrors.length > 0) {
        rewardErrors.forEach(function(error) {
            if (error.discountId) {
                rewardActions.removeReward(error.discountId);
            }
        });
    }
}
// default response for D+ checkout that have no items, we don't want to make an API call so we return the costBreakdown
// with 0 for all values and an empty details array
var emptyCartResponse = function(receipt) {
    return {
        menuTotal: 0,
        cartSubtotal: 0,
        subtotal: 0,
        bottleDepositTaxCents: 0,
        cannabisTax: 0,
        tax: 0,
        deliveryFee: 0,
        credit: 0,
        mixAndMatch: 0,
        reward: 0,
        tip: 0,
        otherFees: 0,
        paymentFee: 0,
        paymentIncentives: [],
        roundupForCharityAmount: 0,
        rounding: 0,
        total: 0,
        details: [],
        lineitems: [
            {
                type: 'productSubtotal',
                value: 0
            },
            {
                type: 'mixAndMatch',
                value: 0
            },
            {
                type: 'discount',
                value: 0
            },
            {
                type: 'reward',
                value: 0,
                brand: 'Reward'
            },
            {
                type: 'paymentFee',
                value: 0
            },
            {
                type: 'deliveryFee',
                value: 0
            },
            {
                type: 'otherFees',
                value: 0
            },
            {
                type: 'tip',
                value: 0
            },
            {
                type: 'bottleDepositTaxCents',
                value: 0
            },
            {
                type: 'cannabisTax',
                value: 0
            },
            {
                type: 'salesTax',
                value: 0
            },
            {
                type: 'rounding',
                value: 0
            },
            {
                type: 'roundupForCharity',
                value: 0
            },
            {
                type: 'total',
                value: 0
            }
        ],
        salesTaxExistence: {},
        cannabisTaxExistence: {},
        bottleDepositTaxExistence: {},
        receipt: receipt.toJSON(),
        coupon: null,
        // POS-13717: Empty array for applied discounts with metadata
        appliedDiscountsWithMetadata: []
    };
};
var extractTimeoutError = function(error) {
    return error.message && error.message.includes('Service Unavailable') || _.some(error.graphQLErrors, [
        'message',
        'Service Unavailable'
    ]);
};
var calculateMenuTotal = function(details) {
    var discount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var total = Big(0);
    _.forEach(details, function(detail) {
        total = total.plus(detail.menuPrice);
    });
    return centsToDollars(total.minus(discount));
};
var getMixAndMatchValue = function(settings, isDelivery) {
    if (isDelivery) {
        return settings === null || settings === void 0 ? void 0 : settings.enableMixAndMatchPricingForDelivery;
    }
    return settings === null || settings === void 0 ? void 0 : settings.enableMixAndMatchPricingForPickup;
};
var extractSpecialsFromCart = function(cartItems) {
    var allSpecials = _.flatMap(cartItems, function(item) {
        var _item_product_specialData, _item_product_specialData1;
        return _to_consumable_array(((_item_product_specialData = item.product.specialData) === null || _item_product_specialData === void 0 ? void 0 : _item_product_specialData.saleSpecials) || []).concat(_to_consumable_array(((_item_product_specialData1 = item.product.specialData) === null || _item_product_specialData1 === void 0 ? void 0 : _item_product_specialData1.bogoSpecials) || []));
    });
    return _.uniqBy(allSpecials, 'specialId');
};
var serializeGamificationDetails = function(gamificationDetails) {
    var cartItems = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, cartSpecials = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    if (!gamificationDetails || _.isEmpty(gamificationDetails)) {
        return [];
    }
    var specialsIndex = _.keyBy(cartSpecials, 'sourceId');
    return _.chain(gamificationDetails).map(function(discount) {
        var equivalentCartSpecial = specialsIndex[discount.discountId.toString()];
        if (!equivalentCartSpecial) {
            return null;
        }
        var thresholds = _.map(discount.satisfiers, function(satisfier) {
            var applicableProducts = [];
            var currentAmount = _.reduce(satisfier.products, function(sum, product) {
                if (product.ecommKey && cartItems[product.ecommKey]) {
                    applicableProducts.push({
                        productKey: product.ecommKey,
                        amount: product.amount
                    });
                    return sum + product.amount;
                }
                return sum;
            }, 0);
            return {
                // One of: GAMIFICATION_THRESHOLD_TYPES.NUMBER_OF_ITEMS | PRODUCT_GRAMS | SPENDING_AMOUNT
                thresholdType: satisfier.thresholdType,
                threshold: satisfier.minimumThreshold,
                thresholdMet: satisfier.thresholdMet,
                currentAmount: currentAmount,
                applicableProducts: applicableProducts
            };
        });
        return {
            specialId: equivalentCartSpecial.specialId,
            specialName: equivalentCartSpecial.specialName,
            allThresholdsMet: discount.meetsAllConstraints,
            thresholds: thresholds
        };
    }).compact().value(); // Remove null entries
};
// Export helper functions for testing
export { extractAppliedDiscounts, extractSpecialsFromCart, serializeGamificationDetails };
